// import React, { useState, useEffect } from "react";
// import Loader from "../../Shared/Loader";

// import "../../../css/EditAppointmentDetailsModal.css";
// import api from "../../../api/axiosConfig";
// // ConfirmationModal removed: delete action is moved to parent View modal
// import { showToast } from '../../Shared/Toaster';


// interface Appointment {
//   id: string; // Center ID
//   appointmentId: string; // Appointment Cluster ID
//   centerName: string;
//   centerType: string;
//   city: string;
//   startDate: string;
//   endDate: string;
//   slotDesigns: Record<string, string>;
//   totalSlots: number;
//   appointmentsPerSlot?: number;
// }

// interface SlotTemplate {
//   _id: string;
//   name: string;
// }

// interface EditModalProps {
//   appointment: Appointment;
//   onClose: () => void;
//   onSaveSuccess: () => void;
// }

// const formatDateForInput = (dateStr: string) => {
//   if (!dateStr || dateStr.split("-").length !== 3) {
//     return "";
//   }
//   const parts = dateStr.split("-");
//   if (parts[0].length === 4) {
//     return dateStr;
//   }
//   const [day, month, year] = parts;
//   return `${year}-${month}-${day}`;
// };

// const EditAppointmentDetailsModal: React.FC<EditModalProps> = ({
//   appointment,
//   onClose,
//   onSaveSuccess,
// }) => {
//   const [editedStartDate, setEditedStartDate] = useState("");
//   const [editedEndDate, setEditedEndDate] = useState("");
//   const [dateError, setDateError] = useState("");
//   const [editedSlotDesigns, setEditedSlotDesigns] = useState<Record<string, string>>({});
//   const [reasonForChange, setReasonForChange] = useState("");
//   const [singleOverrideDate, setSingleOverrideDate] = useState("");
//   const [singleOverrideTemplateId, setSingleOverrideTemplateId] = useState("");
//   const [availableSlotTemplates, setAvailableSlotTemplates] = useState<SlotTemplate[]>([]);
//   const [isLoadingTemplates, setIsLoadingTemplates] = useState(true);
//   const [templateError, setTemplateError] = useState<string | null>(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [impactedBookingsCount, setImpactedBookingsCount] = useState<number>(0);
//   const [isPreviewLoading, setIsPreviewLoading] = useState<boolean>(false);
//   const today = new Date().toISOString().split('T')[0];

//   useEffect(() => {
//     setEditedStartDate(formatDateForInput(appointment.startDate));
//     setEditedEndDate(formatDateForInput(appointment.endDate));

//     const initialDesigns: Record<string, string> = {};
//     if (appointment.slotDesigns) {
//       for (const day in appointment.slotDesigns) {
//         const formattedKey = appointment.centerType === "CAMP CENTER" ? day : day.toLowerCase();
//         initialDesigns[formattedKey] = appointment.slotDesigns[day];
//       }
//     }
//     setEditedSlotDesigns(initialDesigns);
//   }, [appointment]);

//   useEffect(() => {
//     const fetchAvailableSlotTemplates = async () => {
//       try {
//         const token = sessionStorage.getItem("accessToken");
//         const response = await api.appointment_api.get("/api/slot-templates", {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         const templates = (response.data || []).filter((t: any) => !t.disabled_on);
//         setAvailableSlotTemplates(templates);
//       } catch (err) {
//         setTemplateError("Could not load available slot templates.");
//       } finally {
//         setIsLoadingTemplates(false);
//       }
//     };
//     fetchAvailableSlotTemplates();
//   }, []);

//   // Fetch impacted bookings count preview dynamically on template/date change
//   useEffect(() => {
//     const fetchImpactPreview = async () => {
//       if (!appointment.appointmentId || isLoadingTemplates) return;

//       try {
//         setIsPreviewLoading(true);
//         const token = sessionStorage.getItem("accessToken");

//         const map: Record<string, string> = {};
//         if (appointment.centerType === "CAMP CENTER") {
//           Object.keys(editedSlotDesigns).forEach((dateKey) => {
//             const templateName = editedSlotDesigns[dateKey];
//             if (templateName && templateName !== "none") {
//               const foundTemplate = availableSlotTemplates.find((t) => t.name === templateName);
//               map[dateKey] = foundTemplate ? foundTemplate._id : "none";
//             } else {
//               map[dateKey] = "none";
//             }
//           });
//         } else {
//           const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
//           for (const day of days) {
//             const templateName = editedSlotDesigns[day.toLowerCase()];
//             if (templateName && templateName !== "none") {
//               const foundTemplate = availableSlotTemplates.find((t) => t.name === templateName);
//               map[day] = foundTemplate ? foundTemplate._id : "none";
//             } else {
//               map[day] = "none";
//             }
//           }
//         }

//         const payload: Record<string, any> = {
//           weekday_template_map: map,
//         };

//         if (editedStartDate) {
//           payload.start_date = editedStartDate;
//         }
//         if (editedEndDate) {
//           payload.end_date = editedEndDate;
//         }

//         const res = await api.appointment_api.post(
//           `/api/cluster/clusters/${appointment.appointmentId}/preview-template-change`,
//           payload,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         if (res.data && res.data.impacted_bookings_count !== undefined) {
//           setImpactedBookingsCount(res.data.impacted_bookings_count);
//         } else if (res.data && res.data.impacted_bookings !== undefined) {
//           setImpactedBookingsCount(res.data.impacted_bookings);
//         }
//       } catch (err) {
//         console.error("Failed to fetch impact preview:", err);
//       } finally {
//         setIsPreviewLoading(false);
//       }
//     };

//     const timeoutId = setTimeout(() => {
//       fetchImpactPreview();
//     }, 300);

//     return () => clearTimeout(timeoutId);
//   }, [
//     appointment.appointmentId,
//     appointment.centerType,
//     editedStartDate,
//     editedEndDate,
//     editedSlotDesigns,
//     availableSlotTemplates,
//     isLoadingTemplates,
//   ]);

//   const handleSlotTemplateChange = (day: string, value: string) => {
//     const formattedKey = appointment.centerType === "CAMP CENTER" ? day : day.toLowerCase();
//     setEditedSlotDesigns((prev) => ({ ...prev, [formattedKey]: value }));
//   };

//   const handleStartDateChange = (value: string) => {
//     if (value && value < today) {
//       setDateError("Start date must be today or a future date.");
//       showToast("Start date must be today or a future date.", 'error');
//       return;
//     }

//     setEditedStartDate(value);

//     if (editedEndDate && value && new Date(value) > new Date(editedEndDate)) {
//       setDateError("The end date cannot be before the start date.");
//       setEditedEndDate("");
//       showToast("The end date cannot be before the start date.", 'error');
//       return;
//     }

//     if (editedEndDate && value && new Date(value) <= new Date(editedEndDate)) {
//       setDateError("");
//     }
//   };

//   const handleEndDateChange = (value: string) => {
//     if (value && value < today) {
//       setDateError("End date must be today or a future date.");
//       showToast("End date must be today or a future date.", 'error');
//       return;
//     }

//     if (editedStartDate && value && new Date(value) < new Date(editedStartDate)) {
//       setDateError("The end date cannot be before the start date.");
//       setEditedEndDate("");
//       showToast("The end date cannot be before the start date.", 'error');
//       return;
//     }

//     setEditedEndDate(value);
//     setDateError("");
//   };

//   const handleSave = async () => {
//     if (!reasonForChange.trim()) {
//       showToast("Please provide a reason for changing the appointment.", 'error');
//       return;
//     }

//     if (editedStartDate && editedStartDate < today) {
//       showToast("Start date must be today or a future date.", 'error');
//       setDateError("Start date must be today or a future date.");
//       return;
//     }

//     if (editedEndDate && editedEndDate < today) {
//       showToast("End date must be today or a future date.", 'error');
//       setDateError("End date must be today or a future date.");
//       return;
//     }

//     if (editedStartDate && editedEndDate && new Date(editedEndDate) < new Date(editedStartDate)) {
//       showToast("The end date cannot be before the start date.", 'error');
//       setDateError("The end date cannot be before the start date.");
//       return;
//     }
//     setIsSaving(true);
//     try {
//       const token = sessionStorage.getItem("accessToken");
      
//       const weekday_template_map: { [key: string]: string } = {};
      
//       if (appointment.centerType === "CAMP CENTER") {
//         Object.keys(editedSlotDesigns).forEach(dateKey => {
//           const templateName = editedSlotDesigns[dateKey];
//           if (templateName && templateName !== 'none') {
//             const foundTemplate = availableSlotTemplates.find(t => t.name === templateName);
//             weekday_template_map[dateKey] = foundTemplate ? foundTemplate._id : 'none';
//           } else {
//             weekday_template_map[dateKey] = 'none';
//           }
//         });
//       } else {
//         const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
//         for (const day of days) {
//           const templateName = editedSlotDesigns[day.toLowerCase()];
//           if (templateName && templateName !== 'none') {
//             const foundTemplate = availableSlotTemplates.find(t => t.name === templateName);
//             weekday_template_map[day] = foundTemplate ? foundTemplate._id : 'none';
//           } else {
//             weekday_template_map[day] = 'none';
//           }
//         }
//       }

//       const payload = {
//         appointment_cluster_id: appointment.appointmentId,
//         centerId: appointment.id,
//         screeningStartDate: editedStartDate,
//         screeningEndDate: editedEndDate,
//         weekday_template_map: weekday_template_map,
//         reasonForChange: reasonForChange,
//       };
      
//       const promises = [];
//       promises.push(
//         api.appointment_api.put(`/api/released-slots`, payload, {
//           headers: { Authorization: `Bearer ${token}` },
//         })
//       );

//       if (singleOverrideDate && singleOverrideTemplateId) {
//         const singleDayPayload = {
//           appointment_cluster_id: appointment.appointmentId,
//           date: singleOverrideDate,
//           slot_template_id: singleOverrideTemplateId,
//           total_appt_per_slot: appointment.totalSlots,
//           updated_by: "Admin",
//           reason: reasonForChange
//         };
//         promises.push(
//           api.appointment_api.put(`/api/released-slots/single-day`, singleDayPayload, {
//             headers: { Authorization: `Bearer ${token}` },
//           })
//         );
//       }

//       await Promise.all(promises);

//       showToast("Appointment details saved!", 'success');
//       onSaveSuccess();
//     } catch (error: any) {
//       showToast(error.response?.data?.message || "An error occurred while saving.", 'error');
//     } finally {
//       setIsSaving(false);
//     }
//   };


//   const handleDeleteClick = () => {
//     // Delete button moved to parent View modal
//   };

//   const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

//   return (
//     <>
//       <div className="modal-backdrop" onClick={onClose}>
//         <div className="edit-modal-content" onClick={(e) => e.stopPropagation()}>
//           <div className="modal-header-edit-apt">
//             <h2 className="modal-header-edit-apt-title">Edit {appointment.centerType}</h2>
//             <button className="global-close-btn" onClick={onClose}>✕</button>
//           </div>
          
//           <div className="edit-details-section">
//             {/* <div className="detail-item"><span className="label">Appointment Cluster ID</span><span className="value">{appointment.appointmentId}</span></div> */}
//             <div className="detail-item"><span className="label">Center Name</span><span className="value">{appointment.centerName}</span></div>
//             <div className="detail-item"><span className="label">Center Type</span><span className="value">{appointment.centerType}</span></div>
//             <div className="detail-item"><span className="label">City</span><span className="value">{appointment.city}</span></div>
//           </div>
          
//           <div className="date-edit-grid">
//             <div className="date-item">
//               <label>Start Date</label>
//               <div className="input-with-icon">
//                 <input type="date" min={today} value={editedStartDate} onChange={(e) => handleStartDateChange(e.target.value)} />
//               </div>
//             </div>
//             <div className="date-item">
//               <label>End Date</label>
//               <div className="input-with-icon">
//                 <input type="date" min={editedStartDate || today} value={editedEndDate} onChange={(e) => handleEndDateChange(e.target.value)} />
//               </div>
//             </div>
//           </div>
//           {dateError && <div style={{ color: '#d32f2f', fontSize: '13px', marginTop: '8px' }}>{dateError}</div>}
          
//           <h3 className="section-title-config">Edit Template</h3>
//           <table className="slot-template-table">
//             <thead><tr><th>Day</th><th>Slot Template</th></tr></thead>
//             <tbody>
//               {isLoadingTemplates ? (<tr><td colSpan={2}><Loader inline text="Loading Templates..." /></td></tr>) : templateError ? (<tr><td colSpan={2} style={{ color: 'red' }}>{templateError}</td></tr>) : (
//                 appointment.centerType === "CAMP CENTER" ? (
//                   Object.keys(editedSlotDesigns).length > 0 ? (
//                     Object.keys(editedSlotDesigns).map((dateKey) => (
//                       <tr key={dateKey}>
//                         <td>{dateKey}</td>
//                         <td>
//                           <select value={editedSlotDesigns[dateKey] || "none"} onChange={(e) => handleSlotTemplateChange(dateKey, e.target.value)} className="slot-select">
//                             <option value="none">none</option>
//                             {availableSlotTemplates.map((template) => (
//                               <option key={template._id} value={template.name}>{template.name}</option>
//                             ))}
//                           </select>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr><td colSpan={2} style={{ textAlign: "center" }}>No dates found</td></tr>
//                   )
//                 ) : (
//                   daysOfWeek.map((day) => (
//                     <tr key={day}>
//                       <td>{day}</td>
//                       <td>
//                         <select value={editedSlotDesigns[day.toLowerCase()] || "none"} onChange={(e) => handleSlotTemplateChange(day, e.target.value)} className="slot-select">
//                           <option value="none">none</option>
//                           {availableSlotTemplates.map((template) => (
//                             <option key={template._id} value={template.name}>{template.name}</option>
//                           ))}
//                         </select>
//                       </td>
//                     </tr>
//                   ))
//                 )
//               )}
//             </tbody>
//           </table>
          
//           <div className="impacted-bookings-section">
//             <label>No. Impacted Booking IDs</label>
//             <p>{isPreviewLoading ? "Calculating..." : impactedBookingsCount}</p>
//           </div>

//           <h3 className="section-title-config">Single Day Override (Optional)</h3>
//           <div className="date-edit-grid" style={{ marginBottom: '16px' }}>
//             <div className="date-item">
//               <label>Select Date</label>
//               <div className="input-with-icon">
//                 <input 
//                   type="date" 
//                   min={editedStartDate} 
//                   max={editedEndDate} 
//                   value={singleOverrideDate} 
//                   onChange={(e) => setSingleOverrideDate(e.target.value)} 
//                 />
//               </div>
//             </div>
//             <div className="date-item">
//               <label>Select Template</label>
//               <select 
//                 value={singleOverrideTemplateId} 
//                 onChange={(e) => setSingleOverrideTemplateId(e.target.value)} 
//                 className="slot-select"
//               >
//                 <option value="">No Override</option>
//                 {availableSlotTemplates.map((template) => (
//                   <option key={template._id} value={template._id}>{template.name}</option>
//                 ))}
//               </select>
//             </div>
//           </div>
          
//           <div className="reason-section">
//             <label htmlFor="reasonForChange">Reason For Changing Appointment</label>
//             <textarea id="reasonForChange" placeholder="This is the reason for changing" value={reasonForChange} onChange={(e) => setReasonForChange(e.target.value)}></textarea>
//           </div>
          
//           <div className="modal-actions">
//             <button className="btn-save" onClick={handleSave} disabled={isSaving}>{isSaving ? "Saving..." : "Save Edits & Notify"}</button>
//           </div>
//         </div>
//       </div>

//       {/* Delete confirmation moved to parent View modal */}
//     </>
//   );
// };

// export default EditAppointmentDetailsModal;







import React, { useState, useEffect } from "react";
import Loader from "../../Shared/Loader";

import "../../../css/EditAppointmentDetailsModal.css";
import api from "../../../api/axiosConfig";
// ConfirmationModal removed: delete action is moved to parent View modal
import { showToast } from '../../Shared/Toaster';


interface Appointment {
  id: string; // Center ID
  appointmentId: string; // Appointment Cluster ID
  centerName: string;
  centerType: string;
  city: string;
  startDate: string;
  endDate: string;
  slotDesigns: Record<string, string>;
  totalSlots: number;
  appointmentsPerSlot?: number;
}

interface SlotTemplate {
  _id: string;
  name: string;
}

interface EditModalProps {
  appointment: Appointment;
  onClose: () => void;
  onSaveSuccess: () => void;
}

const formatDateForInput = (dateStr: string) => {
  if (!dateStr || dateStr.split("-").length !== 3) {
    return "";
  }
  const parts = dateStr.split("-");
  if (parts[0].length === 4) {
    return dateStr;
  }
  const [day, month, year] = parts;
  return `${year}-${month}-${day}`;
};

const EditAppointmentDetailsModal: React.FC<EditModalProps> = ({
  appointment,
  onClose,
  onSaveSuccess,
}) => {
  const [editedStartDate, setEditedStartDate] = useState("");
  const [editedEndDate, setEditedEndDate] = useState("");
  const [dateError, setDateError] = useState("");
  const [editedSlotDesigns, setEditedSlotDesigns] = useState<Record<string, string>>({});
  const [reasonForChange, setReasonForChange] = useState("");
  const [singleOverrideDate, setSingleOverrideDate] = useState("");
  const [singleOverrideTemplateId, setSingleOverrideTemplateId] = useState("");
  const [availableSlotTemplates, setAvailableSlotTemplates] = useState<SlotTemplate[]>([]);
  const [isLoadingTemplates, setIsLoadingTemplates] = useState(true);
  const [templateError, setTemplateError] = useState<string | null>(null);
  const [isSaving, setIsSaving] = useState(false);
  const [impactedBookingsCount, setImpactedBookingsCount] = useState<number>(0);
  const [isPreviewLoading, setIsPreviewLoading] = useState<boolean>(false);
  // Use the user's local calendar date instead of UTC.
  const now = new Date();
  const today = new Date(now.getTime() - now.getTimezoneOffset() * 60_000)
    .toISOString()
    .split("T")[0];

  useEffect(() => {
    setEditedStartDate(formatDateForInput(appointment.startDate));
    setEditedEndDate(formatDateForInput(appointment.endDate));

    const initialDesigns: Record<string, string> = {};
    if (appointment.slotDesigns) {
      for (const day in appointment.slotDesigns) {
        const formattedKey = appointment.centerType === "CAMP CENTER" ? day : day.toLowerCase();
        initialDesigns[formattedKey] = appointment.slotDesigns[day];
      }
    }
    setEditedSlotDesigns(initialDesigns);
  }, [appointment]);

  useEffect(() => {
    const fetchAvailableSlotTemplates = async () => {
      try {
        const token = sessionStorage.getItem("accessToken");
        const response = await api.appointment_api.get("/api/slot-templates", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const templates = (response.data || []).filter(
          (t: any) => !t.disabled_on && !t.disabled
        );
        setAvailableSlotTemplates(templates);
      } catch (err) {
        setTemplateError("Could not load available slot templates.");
      } finally {
        setIsLoadingTemplates(false);
      }
    };
    fetchAvailableSlotTemplates();
  }, []);

  // Fetch impacted bookings count preview dynamically on template/date change
  useEffect(() => {
    const fetchImpactPreview = async () => {
      if (!appointment.appointmentId || isLoadingTemplates) return;

      try {
        setIsPreviewLoading(true);
        const token = sessionStorage.getItem("accessToken");

        const map: Record<string, string> = {};
        if (appointment.centerType === "CAMP CENTER") {
          Object.keys(editedSlotDesigns).forEach((dateKey) => {
            const templateName = editedSlotDesigns[dateKey];
            if (templateName && templateName !== "none") {
              const foundTemplate = availableSlotTemplates.find((t) => t.name === templateName);
              map[dateKey] = foundTemplate ? foundTemplate._id : "none";
            } else {
              map[dateKey] = "none";
            }
          });
        } else {
          const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
          for (const day of days) {
            const templateName = editedSlotDesigns[day.toLowerCase()];
            if (templateName && templateName !== "none") {
              const foundTemplate = availableSlotTemplates.find((t) => t.name === templateName);
              map[day] = foundTemplate ? foundTemplate._id : "none";
            } else {
              map[day] = "none";
            }
          }
        }

        const payload: Record<string, any> = {
          weekday_template_map: map,
        };

        if (editedStartDate) {
          payload.start_date = editedStartDate;
        }
        if (editedEndDate) {
          payload.end_date = editedEndDate;
        }

        const res = await api.appointment_api.post(
          `/api/cluster/clusters/${appointment.appointmentId}/preview-template-change`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.data && res.data.impacted_bookings_count !== undefined) {
          setImpactedBookingsCount(res.data.impacted_bookings_count);
        } else if (res.data && res.data.impacted_bookings !== undefined) {
          setImpactedBookingsCount(res.data.impacted_bookings);
        }
      } catch (err) {
        console.error("Failed to fetch impact preview:", err);
      } finally {
        setIsPreviewLoading(false);
      }
    };

    const timeoutId = setTimeout(() => {
      fetchImpactPreview();
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [
    appointment.appointmentId,
    appointment.centerType,
    editedStartDate,
    editedEndDate,
    editedSlotDesigns,
    availableSlotTemplates,
    isLoadingTemplates,
  ]);

  const handleSlotTemplateChange = (day: string, value: string) => {
    const formattedKey = appointment.centerType === "CAMP CENTER" ? day : day.toLowerCase();
    setEditedSlotDesigns((prev) => ({ ...prev, [formattedKey]: value }));
  };

  const handleStartDateChange = (value: string) => {
    if (value && value < today) {
      setDateError("Start date must be today or a future date.");
      showToast("Start date must be today or a future date.", 'error');
      return;
    }

    setEditedStartDate(value);

    if (editedEndDate && value && new Date(value) > new Date(editedEndDate)) {
      setDateError("The end date cannot be before the start date.");
      setEditedEndDate("");
      showToast("The end date cannot be before the start date.", 'error');
      return;
    }

    if (editedEndDate && value && new Date(value) <= new Date(editedEndDate)) {
      setDateError("");
    }
  };

  const handleEndDateChange = (value: string) => {
    if (value && value < today) {
      setDateError("End date must be today or a future date.");
      showToast("End date must be today or a future date.", 'error');
      return;
    }

    if (editedStartDate && value && new Date(value) < new Date(editedStartDate)) {
      setDateError("The end date cannot be before the start date.");
      setEditedEndDate("");
      showToast("The end date cannot be before the start date.", 'error');
      return;
    }

    setEditedEndDate(value);
    setDateError("");
  };

  const handleSave = async () => {
    if (!reasonForChange.trim()) {
      showToast("Please provide a reason for changing the appointment.", "error");
      return;
    }

    const hasOverrideDate = Boolean(singleOverrideDate);
    const hasOverrideTemplate = Boolean(singleOverrideTemplateId);
    const isSingleDayOverride = hasOverrideDate && hasOverrideTemplate;

    // A date and template must be selected together for a single-day override.
    if (hasOverrideDate !== hasOverrideTemplate) {
      showToast(
        "Please select both the override date and the override template.",
        "error"
      );
      return;
    }

    /*
     * Single-day override is a separate edit operation.
     * Do not validate or submit the cluster's existing start/end dates here,
     * because an active cluster may already have a past start date.
     * The selected override date represents both the start and end of this
     * one-day change.
     */
    if (isSingleDayOverride) {
      if (singleOverrideDate < today) {
        showToast(
          "The single-day override date must be today or a future date.",
          "error"
        );
        return;
      }

      if (editedStartDate && singleOverrideDate < editedStartDate) {
        showToast(
          "The single-day override date must be within the appointment date range.",
          "error"
        );
        return;
      }

      if (editedEndDate && singleOverrideDate > editedEndDate) {
        showToast(
          "The single-day override date must be within the appointment date range.",
          "error"
        );
        return;
      }

      setIsSaving(true);
      try {
        const token = sessionStorage.getItem("accessToken");
        const singleDayPayload = {
          appointment_cluster_id: appointment.appointmentId,
          date: singleOverrideDate,
          slot_template_id: singleOverrideTemplateId,
          total_appt_per_slot: appointment.totalSlots,
          updated_by: "Admin",
          reason: reasonForChange,
        };

        await api.appointment_api.put(
          "/api/released-slots/single-day",
          singleDayPayload,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        showToast("Single-day override saved!", "success");
        onSaveSuccess();
      } catch (error: any) {
        showToast(
          error.response?.data?.message ||
            "An error occurred while saving the single-day override.",
          "error"
        );
      } finally {
        setIsSaving(false);
      }
      return;
    }

    // Normal cluster edit validation applies only when no single-day override is selected.
    if (editedStartDate && editedStartDate < today) {
      showToast("Start date must be today or a future date.", "error");
      setDateError("Start date must be today or a future date.");
      return;
    }

    if (editedEndDate && editedEndDate < today) {
      showToast("End date must be today or a future date.", "error");
      setDateError("End date must be today or a future date.");
      return;
    }

    if (
      editedStartDate &&
      editedEndDate &&
      new Date(editedEndDate) < new Date(editedStartDate)
    ) {
      showToast("The end date cannot be before the start date.", "error");
      setDateError("The end date cannot be before the start date.");
      return;
    }

    setIsSaving(true);
    try {
      const token = sessionStorage.getItem("accessToken");
      const weekday_template_map: Record<string, string> = {};

      if (appointment.centerType === "CAMP CENTER") {
        Object.keys(editedSlotDesigns).forEach((dateKey) => {
          const templateName = editedSlotDesigns[dateKey];
          if (templateName && templateName !== "none") {
            const foundTemplate = availableSlotTemplates.find(
              (template) => template.name === templateName
            );
            weekday_template_map[dateKey] = foundTemplate
              ? foundTemplate._id
              : "none";
          } else {
            weekday_template_map[dateKey] = "none";
          }
        });
      } else {
        const days = [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ];

        for (const day of days) {
          const templateName = editedSlotDesigns[day.toLowerCase()];
          if (templateName && templateName !== "none") {
            const foundTemplate = availableSlotTemplates.find(
              (template) => template.name === templateName
            );
            weekday_template_map[day] = foundTemplate
              ? foundTemplate._id
              : "none";
          } else {
            weekday_template_map[day] = "none";
          }
        }
      }

      const payload = {
        appointment_cluster_id: appointment.appointmentId,
        centerId: appointment.id,
        start_date: editedStartDate,
        end_date: editedEndDate,
        weekday_template_map,
        reasonForChange,
      };

      await api.appointment_api.put("/api/released-slots", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      showToast("Appointment details saved!", "success");
      onSaveSuccess();
    } catch (error: any) {
      showToast(
        error.response?.data?.message || "An error occurred while saving.",
        "error"
      );
    } finally {
      setIsSaving(false);
    }
  };


  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

  const getDayAndDate = (dateKey: string) => {
    // 1. Check if dateKey itself is a valid date (e.g. YYYY-MM-DD or DD-MM-YYYY)
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateKey)) {
      const [yyyy, mm, dd] = dateKey.split("-");
      const d = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
      const dayName = isNaN(d.getTime()) ? dateKey : d.toLocaleDateString("en-US", { weekday: "long" });
      const formattedDate = `${dd}-${mm}-${yyyy}`;
      return { day: dayName, date: formattedDate };
    }

    if (/^\d{2}-\d{2}-\d{4}$/.test(dateKey)) {
      const [dd, mm, yyyy] = dateKey.split("-");
      const d = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
      const dayName = isNaN(d.getTime()) ? dateKey : d.toLocaleDateString("en-US", { weekday: "long" });
      return { day: dayName, date: dateKey };
    }

    // 2. If dateKey is a Day name (e.g. "Tuesday"), map it with editedStartDate/editedEndDate range
    if (editedStartDate) {
      const parts = editedStartDate.split("-");
      if (parts.length === 3) {
        let start: Date;
        if (parts[0].length === 4) {
          start = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
        } else {
          start = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
        }

        let end = start;
        if (editedEndDate) {
          const endParts = editedEndDate.split("-");
          if (endParts.length === 3) {
            if (endParts[0].length === 4) {
              end = new Date(parseInt(endParts[0]), parseInt(endParts[1]) - 1, parseInt(endParts[2]));
            } else {
              end = new Date(parseInt(endParts[2]), parseInt(endParts[1]) - 1, parseInt(endParts[0]));
            }
          }
        }

        if (!isNaN(start.getTime())) {
          const curr = new Date(start);
          while (curr <= end) {
            const currDay = curr.toLocaleDateString("en-US", { weekday: "long" });
            if (currDay.toLowerCase() === dateKey.toLowerCase()) {
              const dd = String(curr.getDate()).padStart(2, "0");
              const mm = String(curr.getMonth() + 1).padStart(2, "0");
              const yyyy = curr.getFullYear();
              return { day: currDay, date: `${dd}-${mm}-${yyyy}` };
            }
            curr.setDate(curr.getDate() + 1);
          }

          // Fallback date from start date
          const dd = String(start.getDate()).padStart(2, "0");
          const mm = String(start.getMonth() + 1).padStart(2, "0");
          const yyyy = start.getFullYear();
          return { day: dateKey, date: `${dd}-${mm}-${yyyy}` };
        }
      }
    }

    return { day: dateKey, date: editedStartDate || "—" };
  };

  return (
    <>
      <div className="modal-backdrop" onClick={onClose}>
        <div className="edit-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header-edit-apt">
            <h2 className="modal-header-edit-apt-title">Edit {appointment.centerType}</h2>
            <button className="global-close-btn" onClick={onClose}>✕</button>
          </div>
          
          <div className="edit-details-section">
            <div className="detail-item"><span className="label">Center Name</span><span className="value">{appointment.centerName}</span></div>
            <div className="detail-item"><span className="label">Center Type</span><span className="value">{appointment.centerType}</span></div>
            <div className="detail-item"><span className="label">City</span><span className="value">{appointment.city}</span></div>
          </div>
          
          <div className="date-edit-grid">
            <div className="date-item">
              <label>Start Date</label>
              <div className="input-with-icon">
                <input type="date" min={today} value={editedStartDate} onChange={(e) => handleStartDateChange(e.target.value)} />
              </div>
            </div>
            <div className="date-item">
              <label>End Date</label>
              <div className="input-with-icon">
                <input type="date" min={editedStartDate || today} value={editedEndDate} onChange={(e) => handleEndDateChange(e.target.value)} />
              </div>
            </div>
          </div>
          {dateError && <div style={{ color: '#d32f2f', fontSize: '13px', marginTop: '8px' }}>{dateError}</div>}
          
          <h3 className="section-title-config">Edit Template</h3>
          <table className="slot-template-table">
            <thead>
              <tr>
                <th>Day</th>
                {appointment.centerType === "CAMP CENTER" && <th>Date</th>}
                <th>Slot Template</th>
              </tr>
            </thead>
            <tbody>
              {isLoadingTemplates ? (
                <tr>
                  <td colSpan={appointment.centerType === "CAMP CENTER" ? 3 : 2}>
                    <Loader inline text="Loading Templates..." />
                  </td>
                </tr>
              ) : templateError ? (
                <tr>
                  <td colSpan={appointment.centerType === "CAMP CENTER" ? 3 : 2} style={{ color: 'red' }}>
                    {templateError}
                  </td>
                </tr>
              ) : (
                appointment.centerType === "CAMP CENTER" ? (
                  Object.keys(editedSlotDesigns).length > 0 ? (
                    Object.keys(editedSlotDesigns).map((dateKey) => {
                      const { day, date } = getDayAndDate(dateKey);
                      return (
                        <tr key={dateKey}>
                          <td>{day}</td>
                          <td>{date}</td>
                          <td>
                            <select value={editedSlotDesigns[dateKey] || "none"} onChange={(e) => handleSlotTemplateChange(dateKey, e.target.value)} className="slot-select">
                              <option value="none">none</option>
                              {availableSlotTemplates.map((template) => (
                                <option key={template._id} value={template.name}>{template.name}</option>
                              ))}
                            </select>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr><td colSpan={3} style={{ textAlign: "center" }}>No dates found</td></tr>
                  )
                ) : (
                  daysOfWeek.map((day) => (
                    <tr key={day}>
                      <td>{day}</td>
                      <td>
                        <select value={editedSlotDesigns[day.toLowerCase()] || "none"} onChange={(e) => handleSlotTemplateChange(day, e.target.value)} className="slot-select">
                          <option value="none">none</option>
                          {availableSlotTemplates.map((template) => (
                            <option key={template._id} value={template.name}>{template.name}</option>
                          ))}
                        </select>
                      </td>
                    </tr>
                  ))
                )
              )}
            </tbody>
          </table>
          
          <div className="impacted-bookings-section">
            <label>No. Impacted Booking IDs</label>
            <p>{isPreviewLoading ? "Calculating..." : impactedBookingsCount}</p>
          </div>

          <h3 className="section-title-config">Single Day Override (Optional)</h3>
          <div className="date-edit-grid" style={{ marginBottom: '16px' }}>
            <div className="date-item">
              <label>Select Date</label>
              <div className="input-with-icon">
                <input 
                  type="date" 
                  min={
                    editedStartDate && editedStartDate > today
                      ? editedStartDate
                      : today
                  }
                  max={editedEndDate || undefined}
                  value={singleOverrideDate}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value && value < today) {
                      showToast(
                        "The single-day override date must be today or a future date.",
                        "error"
                      );
                      return;
                    }
                    setSingleOverrideDate(value);
                  }} 
                />
              </div>
            </div>
            <div className="date-item">
              <label>Select Template</label>
              <select 
                value={singleOverrideTemplateId} 
                onChange={(e) => setSingleOverrideTemplateId(e.target.value)} 
                className="slot-select"
              >
                <option value="">No Override</option>
                {availableSlotTemplates.map((template) => (
                  <option key={template._id} value={template._id}>{template.name}</option>
                ))}
              </select>
            </div>
          </div>
          
          <div className="reason-section">
            <label htmlFor="reasonForChange">Reason For Changing Appointment</label>
            <textarea id="reasonForChange" placeholder="This is the reason for changing" value={reasonForChange} onChange={(e) => setReasonForChange(e.target.value)}></textarea>
          </div>
          
          <div className="modal-actions">
            <button className="btn-save" onClick={handleSave} disabled={isSaving}>{isSaving ? "Saving..." : "Save Edits & Notify"}</button>
          </div>
        </div>
      </div>

      {/* Delete confirmation moved to parent View modal */}
    </>
  );
};

export default EditAppointmentDetailsModal;